var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "#E4EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3337 35.3333H42.0003C41.1163 35.3333 40.2684 35.6844 39.6433 36.3096C39.0182 36.9347 38.667 37.7825 38.667 38.6666V65.3333C38.667 66.2173 39.0182 67.0652 39.6433 67.6903C40.2684 68.3154 41.1163 68.6666 42.0003 68.6666H62.0003C62.8844 68.6666 63.7322 68.3154 64.3573 67.6903C64.9825 67.0652 65.3337 66.2173 65.3337 65.3333V45.3333L55.3337 35.3333Z",
    stroke: "#2D65F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.333 35.3333V45.3333H65.333",
    stroke: "#2D65F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62V52",
    stroke: "#2D65F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 57H57",
    stroke: "#2D65F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.b04790d24b7cbffef676746cc3cea51d.svg";
export { ForwardRef as ReactComponent };